import React, { createContext, useReducer, useContext, ReactNode } from "react";
import { DependentRecord } from '../services/profileService';


// ================= Interfaces =================


interface User {
  id: string;
  name: string;
  email: string;
}


// Expense
export interface Expense {
  id: string;
  expenseOwnerType: string;
  expenseFrequency: string;
  expenseType: string;
  expenseSubType: string;
  expenseAmount: string;
  expenseName: string;
  totalExpenseAmount: string;
  totalFamilyExpenseAmount: string;
  date: string;
}

export type ActionType =
  | "ADD_EXPENSE"
  | "UPDATE_EXPENSE"
  | "DELETE_EXPENSE"
  | "ADD_ASSET"
  | "UPDATE_ASSET"
  | "DELETE_ASSET"
  | "ADD_LIABILITY"
  | "UPDATE_LIABILITY"
  | "DELETE_LIABILITY"
  | "SET_liability"

// Asset (<<<<< UPDATED HERE)
export interface Asset {
  id: string;
  assetOwnerType: string;
  assetType: string;
  assetSubType: string;
  assetName: string;
  assetPurchaseDate: string;
  assetPurchaseValue: number;
  assetUnit: number;
  assetUnitPrice: number;
  assetCurrentPrice: number;
  assetPostCode: string;
  assetLoan: boolean;
  amount: number;
}

// Liability
export interface Liability {
  id: string;
  liabilityOwnerType: string;
  liabilityType: string;
  liabilitySubType: string;
   liabilitySubTypeLabel: string;
  liabilityStartDate: string;
  liabilityEndDate: string;
  liabilityTenure: string;
  liabilityTotalAmount: string;
  liabilityOutstandingAmount: string;
  liabilityInterestRate: string;
  liabilityFrequency: string;
  liabilityInstalmentAmount: string;
}


export interface insurance {
  id: string;
  insuranceOwnerType: string;
  insuranceType: string;
  insuranceSubType: string;
insuranceStartDate: string;
  insuranceEndDate: string;
  insuranceTenure: string;
 insuranceTotalAmount: string;
  insuranceOutstandingAmount: string;
  insuranceInterestRate: string;

}

// Income
export interface Income {
 id: string;
  incomeOwnerType: string;
  incomeType: string;
  incomeSubType: string;
  incomeName: string;
  incomeAmount: string;
  incomeFrequency: string;
  totalIncomeAmount: string;
  totalFamilyIncome: string;
}

// Goal
export interface Goal {
  id: string;
  goalOwnerType: string;
  goalType: string;
  goalSubType: string;
  goalName: string;
  goalTarget: string;
  goalTargetTenure: string;
  goalCompletionTentativeAmount: string;
}

// Profile
export interface Profile {
  name: string;
  relation: string;
  profileType: string;
  gender: string;
  dob: string;
  maritalStatus: string;
  state: string;
  city: string;
  employmentStatus: string;
  retirementAge: number | '';
  profilePicture?: string;
  age?: number;
}

// Dependent
export interface Dependent {
  id: string;
  name: string;
  relation: string;
  age?: number;
  notes?: string;
  profileType: string;
  gender: string;
  dob: string;
  maritalStatus: string;
  state: string;
  city: string;
  employmentStatus: string;
  retirementAge: number | '';
  profilePicture?: string;
}

// Vital
export interface Vital {
  id: string;
  type: string;
  value: string;
}

// Test Report
export interface TestReport {
  id: string;
  title: string;
  result: string;
  notes: string;
}

// Prescription
export interface Prescription {
  id: string;
  medicine: string;
  dosage: string;
}

// ================= State =================
export interface State {
  assets: Asset[];
  liability: Liability[];
  insurance: insurance[];
  incomes: Income[];
  expenses: Expense[];
  goals: Goal[];
  dependents: Dependent[];
  vitals: Vital[];
  testReports: TestReport[];
  prescriptions: Prescription[];
  profile: Profile;
  user: User | null;
  isAuthenticated: boolean;
  currencySymbol: string;// <-- NEW: ADDED FOR GLOBAL CURRENCY SYMBOL
  
}

// ================= Actions =================
type Action =
  | { type: "ADD_EXPENSE"; payload: Expense }
  | { type: "UPDATE_EXPENSE"; payload: Expense }
  | { type: "DELETE_EXPENSE"; payload: string }
  | { type: "LOGIN"; payload: User }
  | { type: "LOGOUT" }

  | { type: "ADD_ASSET"; payload: Asset }
  | { type: "UPDATE_ASSET"; payload: Asset }
  | { type: "DELETE_ASSET"; payload: string }

  | { type: "ADD_LIABILITY"; payload: Liability }
  | { type: "UPDATE_LIABILITY"; payload: Liability }
  | { type: "DELETE_LIABILITY"; payload: string }

  | { type: "ADD_INSURANCE"; payload: insurance }
  | { type: "UPDATE_INSURANCE"; payload: insurance }
  | { type: "DELETE_INSURANCE"; payload: string }

  | { type: "ADD_INCOME"; payload: Income }
  | { type: "UPDATE_INCOME"; payload: Income }
  | { type: "DELETE_INCOME"; payload: string }

  | { type: "ADD_GOAL"; payload: Goal }
  | { type: "UPDATE_GOAL"; payload: Goal }
  | { type: "DELETE_GOAL"; payload: string }

  | { type: "ADD_DEPENDENT"; payload: Dependent }
  | { type: "UPDATE_DEPENDENT"; payload: Dependent }
  | { type: "DELETE_DEPENDENT"; payload: string }
 | { type: 'SET_DEPENDENTS'; payload: DependentRecord[]}

  | { type: "ADD_VITAL"; payload: Vital }
  | { type: "UPDATE_VITAL"; payload: Vital }
  | { type: "DELETE_VITAL"; payload: string }

  | { type: "ADD_TESTREPORT"; payload: TestReport }
  | { type: "UPDATE_TESTREPORT"; payload: TestReport }
  | { type: "DELETE_TESTREPORT"; payload: string }

  | { type: "ADD_PRESCRIPTION"; payload: Prescription }
  | { type: "UPDATE_PRESCRIPTION"; payload: Prescription }
  | { type: "DELETE_PRESCRIPTION"; payload: string }

  | { type: "UPDATE_PROFILE"; payload: Partial<Profile> }
  | { type: "SET_CURRENCY_SYMBOL"; payload: string }; // <-- NEW: ACTION FOR CURRENCY

// ================= Initial State =================
const initialState: State = {
  assets: [],
  liability: [],
  insurance: [],
  incomes: [],
  expenses: [],
  goals: [],
  dependents: [],
  vitals: [],
  testReports: [],
  prescriptions: [],
  profile: {
    name: '',
    relation: '',
    profileType: 'Self',
    gender: '',
    dob: '',
    maritalStatus: '',
    state: '',
    city: '',
    employmentStatus: '',
    retirementAge: 0,
    profilePicture: ''

  },
  user: null,
  isAuthenticated: false,
  currencySymbol: '', // <-- NEW: DEFAULT CURRENCY SYMBOL
};

// ================= Reducer =================
function reducer(state: State, action: Action): State {

   switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload, isAuthenticated: true };
    case "LOGOUT":
      return { ...state, user: null, isAuthenticated: false };

     case "ADD_INCOME":
      return { ...state, incomes: [...state.incomes, action.payload] };
    case "UPDATE_INCOME":
      return {
        ...state,
        incomes: state.incomes.map((i) =>
          i.id === action.payload.id ? action.payload : i
        ),
      };
    case "DELETE_INCOME":
      return {
        ...state,
        incomes: state.incomes.filter((i) => i.id !== action.payload),
      };

    case "ADD_EXPENSE":
      return { ...state, expenses: [...state.expenses, action.payload] };
    case "UPDATE_EXPENSE":
      return {
        ...state,
        expenses: state.expenses.map((exp) =>
          exp.id === action.payload.id ? action.payload : exp
        ),
      };
    case "DELETE_EXPENSE":
      return {
        ...state,
        expenses: state.expenses.filter((exp) => exp.id !== action.payload),
      };

    case "ADD_ASSET":
      return { ...state, assets: [...state.assets, action.payload] };
    case "UPDATE_ASSET":
      return {
        ...state,
        assets: state.assets.map((a) =>
          a.id === action.payload.id ? action.payload : a
        ),
      };
    case "DELETE_ASSET":
      return {
        ...state,
        assets: state.assets.filter((a) => a.id !== action.payload),
      };

    case "ADD_LIABILITY":
      return { ...state, liability: [...state.liability, action.payload] };
    case "UPDATE_LIABILITY":
      return {
        ...state,
        liability: state.liability.map((l) =>
          l.id === action.payload.id ? action.payload : l
        ),
      };
    case "DELETE_LIABILITY":
      return {
        ...state,
        liability: state.liability.filter((l) => l.id !== action.payload),
      };


    case "ADD_INSURANCE":
      return { ...state, insurance: [...state.insurance, action.payload] };
    case "UPDATE_INSURANCE":
      return {
        ...state,
       insurance: state.insurance.map((l) =>
          l.id === action.payload.id ? action.payload : l
        ),
      };
    case "DELETE_INSURANCE":
      return {
        ...state,
        insurance: state.insurance.filter((l) => l.id !== action.payload),
      };

    case "ADD_GOAL":
      return { ...state, goals: [...state.goals, action.payload] };
    case "UPDATE_GOAL":
      return {
        ...state,
        goals: state.goals.map((g) =>
          g.id === action.payload.id ? action.payload : g
        ),
      };
    case "DELETE_GOAL":
      return {
        ...state,
        goals: state.goals.filter((g) => g.id !== action.payload),
      };
      case 'SET_DEPENDENTS':
      return { ...state, dependents: action.payload };

    case "ADD_DEPENDENT":
      return { ...state, dependents: [...state.dependents, action.payload] };
    case "UPDATE_DEPENDENT":
      return {
        ...state,
        dependents: state.dependents.map((d) =>
          d.id === action.payload.id ? action.payload : d
        ),
      };
    case "DELETE_DEPENDENT":
      return {
        ...state,
        dependents: state.dependents.filter((d) => d.id !== action.payload),
      };

    case "ADD_VITAL":
      return { ...state, vitals: [...state.vitals, action.payload] };
    case "UPDATE_VITAL":
      return {
        ...state,
        vitals: state.vitals.map((v) =>
          v.id === action.payload.id ? action.payload : v
        ),
      };
    case "DELETE_VITAL":
      return {
        ...state,
        vitals: state.vitals.filter((v) => v.id !== action.payload),
      };

    case "ADD_TESTREPORT":
      return { ...state, testReports: [...state.testReports, action.payload] };
    case "UPDATE_TESTREPORT":
      return {
        ...state,
        testReports: state.testReports.map((t) =>
          t.id === action.payload.id ? action.payload : t
        ),
      };
    case "DELETE_TESTREPORT":
      return {
        ...state,
        testReports: state.testReports.filter((t) => t.id !== action.payload),
      };

    case "ADD_PRESCRIPTION":
      return {
        ...state,
        prescriptions: [...state.prescriptions, action.payload],
      };
    case "UPDATE_PRESCRIPTION":
      return {
        ...state,
        prescriptions: state.prescriptions.map((p) =>
          p.id === action.payload.id ? action.payload : p
        ),
      };
    case "DELETE_PRESCRIPTION":
      return {
        ...state,
        prescriptions: state.prescriptions.filter((p) => p.id !== action.payload),
      };

    case "UPDATE_PROFILE":
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload
        }
      };

    // <-- NEW: REDUCER CASE FOR UPDATING CURRENCY SYMBOL -->
    case "SET_CURRENCY_SYMBOL":
      return {
        ...state,
        currencySymbol: action.payload
      };


    default:
      return state;
  }

}


// ================= Context =================
const AppContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null,
});






// ================= Provider =================
export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

// ================= Hook =================
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) throw new Error("useAppContext must be used within AppProvider");
  return context;
};